import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

import {
  DateRangesTypeStatus,
  OfferStatusType,
  PaymentStatus,
} from '../../modules/revenueInsightsV2/types'
import { formatFutureRange, formatPastRange } from './revenueHelpers'

export const paymentStatusKeys: { [key: string]: string } = {
  Disbursed: 'disbursed',
  'Not disbursed': 'invoiced',
  Defaulters: 'defaulters',
}

export const paymentStatusRadioMapping: RadioButtonGroupMapping[] = [
  {
    key: PaymentStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
  {
    key: PaymentStatus.DISBURSED,
    label: 'Disbursed',
    type: RadioButtonType.STANDARD,
  },
  {
    key: PaymentStatus.NOT_DISBURSED,
    label: 'Not disbursed',
    type: RadioButtonType.STANDARD,
  },
  {
    key: PaymentStatus.DEFAULTERS,
    label: 'Defaulters',
    type: RadioButtonType.STANDARD,
  },
]

export const offerTypeRadioMapping: RadioButtonGroupMapping[] = [
  {
    key: OfferStatusType.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
  {
    key: OfferStatusType.PUBLIC,
    label: 'Public',
    type: RadioButtonType.STANDARD,
  },
  {
    key: OfferStatusType.PRIVATE,
    label: 'Private',
    type: RadioButtonType.STANDARD,
  },
]

export const DisbursedByDateRangeMapping: RadioButtonGroupMapping[] = [
  {
    key: DateRangesTypeStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
  {
    key: DateRangesTypeStatus.THIRTY,
    label: 'Last 30 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(30),
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.SIXTY,
    label: 'Last 60 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(60),
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.NINETY,
    label: 'Last 90 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(90),
    descriptionPlacement: 'right',
  },
]

export const PaymentDueDateMapping: RadioButtonGroupMapping[] = [
  {
    key: DateRangesTypeStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
  {
    key: DateRangesTypeStatus.THIRTY,
    label: 'Next 30 days',
    type: RadioButtonType.STANDARD,
    description: `Till ${formatFutureRange(30, true)}`,
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.SIXTY,
    label: 'Next 60 days',
    type: RadioButtonType.STANDARD,
    description: `Till ${formatFutureRange(60, true)}`,
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.NINETY,
    label: 'Next 90 days',
    type: RadioButtonType.STANDARD,
    description: `Till ${formatFutureRange(90, true)}`,
    descriptionPlacement: 'right',
  },
]

export const PaymentDelayedSinceMapping: RadioButtonGroupMapping[] = [
  {
    key: DateRangesTypeStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
  {
    key: DateRangesTypeStatus.THIRTY,
    label: 'Last 30 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(30),
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.SIXTY,
    label: 'Last 60 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(60),
    descriptionPlacement: 'right',
  },
  {
    key: DateRangesTypeStatus.NINETY,
    label: 'Last 90 days',
    type: RadioButtonType.STANDARD,
    description: formatPastRange(90),
    descriptionPlacement: 'right',
  },
]
